import { render, staticRenderFns } from "./SchoolKnownStep.vue?vue&type=template&id=4f7355b9&scoped=true&"
import script from "./SchoolKnownStep.vue?vue&type=script&lang=js&"
export * from "./SchoolKnownStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7355b9",
  null
  
)

export default component.exports